









import { PublicCourseDetails } from '@/jbi-shared/dto/jtms-public-course.dtos';
import { RootState } from '@/store/store';
import { Vue, Component } from 'vue-property-decorator';
import { State } from 'vuex-class';

@Component({})
export default class BannerImage extends Vue {
  @State(({ course }: RootState) => course.publicCourseState.courseDetails)
  public publicCourseDetails!: PublicCourseDetails;

  get imageURL(): string {
    if (this.publicCourseDetails.nonDefaultDetails) {
      const details = this.publicCourseDetails.nonDefaultDetails;
      if (
        details['course-banner-image'] &&
        Array.isArray(details['course-banner-image'])
      ) {
        const bannerImage: string = (details[
          'course-banner-image'
        ] as string[])[0];
        return bannerImage;
      }
    }

    return require('@/jbi-shared/assets/images/placeholder-banner.svg');
  }
}
